export class HttpError extends Error {
  static getErrorString(statusCode: number): string {
    switch (statusCode) {
      case 400:
        return "400";
      case 401:
        return "401";
      case 403:
        return "403";
      case 500:
        return "500";
      case 503:
        return "503";
      case 504:
        return "504";
      default:
        return "general";
    }
  }
}
